import availableImage from '../images/tank-available.png'
import notAvailableImage from '../images/tank-not-available.png'
import { VEHICLE_TYPES } from 'constants'

export const clan_supply_progression_settings_mock = () => ({
    enabled: true,
    regions_count: 21,
    prize: {
        available_image: availableImage,
        not_available_image: notAvailableImage,
        type: VEHICLE_TYPES[1],
        level: 10,
        title: 'Carro 45t',
    },
})



// WEBPACK FOOTER //
// ./containers/ClanLanding/mocks/clan_supply_progression_settings_mock.js